"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var MediaLibrary = /*#__PURE__*/function () {
  function MediaLibrary(client) {
    (0, _classCallCheck2["default"])(this, MediaLibrary);
    this.client = client;
    this.resourceUrl = '/medias';
  }

  (0, _createClass2["default"])(MediaLibrary, [{
    key: "getMediaByCategory",
    value: function getMediaByCategory(id) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return this.client.get("".concat(this.resourceUrl, "/categories/").concat(id), args);
    }
  }, {
    key: "getMediaById",
    value: function getMediaById(categoryId, mediaId, journeyId, sequenceId, sessionId) {
      var url = "".concat(this.resourceUrl, "/sub-categories/").concat(categoryId, "/").concat(mediaId);

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      if (sessionId) {
        url += "?sessionId=".concat(sessionId);
      }

      for (var _len2 = arguments.length, args = new Array(_len2 > 5 ? _len2 - 5 : 0), _key2 = 5; _key2 < _len2; _key2++) {
        args[_key2 - 5] = arguments[_key2];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getSignedUrlByMediaId",
    value: function getSignedUrlByMediaId(id, journeyId, sequenceId) {
      var url = "".concat(this.resourceUrl, "/").concat(id, "/signed-url");

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      for (var _len3 = arguments.length, args = new Array(_len3 > 3 ? _len3 - 3 : 0), _key3 = 3; _key3 < _len3; _key3++) {
        args[_key3 - 3] = arguments[_key3];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "saveJournal",
    value: function saveJournal(mediaId, data) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 2 ? _len4 - 2 : 0), _key4 = 2; _key4 < _len4; _key4++) {
        args[_key4 - 2] = arguments[_key4];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(mediaId, "/journal"), data, args);
    }
  }, {
    key: "getNextMedia",
    value: function getNextMedia(categoryId, mediaId, journeyId, sequenceId) {
      var url = "".concat(this.resourceUrl, "/sub-categories/").concat(categoryId, "/").concat(mediaId, "/next");

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      for (var _len5 = arguments.length, args = new Array(_len5 > 4 ? _len5 - 4 : 0), _key5 = 4; _key5 < _len5; _key5++) {
        args[_key5 - 4] = arguments[_key5];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "getPreviousMedia",
    value: function getPreviousMedia(categoryId, mediaId, journeyId, sequenceId) {
      var url = "".concat(this.resourceUrl, "/sub-categories/").concat(categoryId, "/").concat(mediaId, "/previous");

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      for (var _len6 = arguments.length, args = new Array(_len6 > 4 ? _len6 - 4 : 0), _key6 = 4; _key6 < _len6; _key6++) {
        args[_key6 - 4] = arguments[_key6];
      }

      return this.client.get(url, args);
    }
  }, {
    key: "toggleFavorite",
    value: function toggleFavorite(data, id) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
        args[_key7 - 2] = arguments[_key7];
      }

      return this.client.post("".concat(this.resourceUrl, "/").concat(id, "/favorite"), data, args);
    }
  }, {
    key: "updateMediaStatus",
    value: function updateMediaStatus(data, mediaId, journeyId, sequenceId) {
      var url = "".concat(this.resourceUrl, "/").concat(mediaId, "/status");

      if (journeyId) {
        url += "?journeyId=".concat(journeyId, "&sequenceId=").concat(sequenceId);
      }

      for (var _len8 = arguments.length, args = new Array(_len8 > 4 ? _len8 - 4 : 0), _key8 = 4; _key8 < _len8; _key8++) {
        args[_key8 - 4] = arguments[_key8];
      }

      return this.client.post(url, data, args);
    }
  }, {
    key: "getFavorites",
    value: function getFavorites(params) {
      for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key9 = 1; _key9 < _len9; _key9++) {
        args[_key9 - 1] = arguments[_key9];
      }

      return this.client.get("".concat(this.resourceUrl, "/favorites").concat(params), args);
    }
  }, {
    key: "getRecommendedMedias",
    value: function getRecommendedMedias(data) {
      for (var _len10 = arguments.length, args = new Array(_len10 > 1 ? _len10 - 1 : 0), _key10 = 1; _key10 < _len10; _key10++) {
        args[_key10 - 1] = arguments[_key10];
      }

      return this.client.post("".concat(this.resourceUrl, "/recommended"), data, args);
    }
  }, {
    key: "getRecentlyPlayedMedias",
    value: function getRecentlyPlayedMedias(data) {
      for (var _len11 = arguments.length, args = new Array(_len11 > 1 ? _len11 - 1 : 0), _key11 = 1; _key11 < _len11; _key11++) {
        args[_key11 - 1] = arguments[_key11];
      }

      return this.client.post("".concat(this.resourceUrl, "/recently-played"), data, args);
    }
  }, {
    key: "downloadTranscript",
    value: function downloadTranscript(mediaId) {
      for (var _len12 = arguments.length, args = new Array(_len12 > 1 ? _len12 - 1 : 0), _key12 = 1; _key12 < _len12; _key12++) {
        args[_key12 - 1] = arguments[_key12];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(mediaId, "/download-transcript"), args);
    }
  }, {
    key: "getThreeLowestCategory",
    value: function getThreeLowestCategory() {
      for (var _len13 = arguments.length, args = new Array(_len13), _key13 = 0; _key13 < _len13; _key13++) {
        args[_key13] = arguments[_key13];
      }

      return this.client.get("".concat(this.resourceUrl, "/get-three-lowest-category"), args);
    }
  }, {
    key: "getSignedURLForKeySkill",
    value: function getSignedURLForKeySkill(mediaId) {
      for (var _len14 = arguments.length, args = new Array(_len14 > 1 ? _len14 - 1 : 0), _key14 = 1; _key14 < _len14; _key14++) {
        args[_key14 - 1] = arguments[_key14];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(mediaId, "/key-skill/signed-url"), args);
    }
  }, {
    key: "getSignedURLForTranscription",
    value: function getSignedURLForTranscription(mediaId, type) {
      for (var _len15 = arguments.length, args = new Array(_len15 > 2 ? _len15 - 2 : 0), _key15 = 2; _key15 < _len15; _key15++) {
        args[_key15 - 2] = arguments[_key15];
      }

      return this.client.get("".concat(this.resourceUrl, "/").concat(mediaId, "/transcription/signed-url?type=").concat(type), args);
    }
  }]);
  return MediaLibrary;
}();

exports["default"] = MediaLibrary;